"use strict";
import r from "./index.es155.js";
import a from "./index.es144.js";
function i(t, e, o) {
  r.call(this, t ?? "canceled", r.ERR_CANCELED, e, o), this.name = "CanceledError";
}
a.inherits(i, r, {
  __CANCEL__: !0
});
export {
  i as default
};
//# sourceMappingURL=index.es150.js.map
